import {
  Component,
  ElementRef,
  Renderer2,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UtilsService } from 'src/app/services';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { MultiSelectBase } from '../multi-select-base';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from '../../../tooltip/tooltip.module';
@Component({
  selector: 'app-multi-select-form',
  templateUrl: './multi-select-form.component.html',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TooltipModule],
  styleUrls: ['./multi-select-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MultiSelectFormComponent extends MultiSelectBase {
  constructor(
    renderer: Renderer2,
    utilsService: UtilsService,
    literalService: LiteralService,
    eRef: ElementRef,
  ) {
    super(renderer, utilsService, literalService, eRef);
  }
}
